import ApplicationRouter from './ApplicationRouter';
import connectContainer from './ApplicationRouterContainer';

export default connectContainer(ApplicationRouter);
